import React, { Fragment } from "react";
import propTypes from "prop-types";
import "./style.css";

/**
 * Breadcrumbs component to display the navigation path.
 * @param {Object[]} phases - The phases array containing phase objects.
 * @param {string} phases.currTitle - The title of the phase.
 * @param {string} phases.currPhase - The identifier of the phase.
 * @param {string} currPhase - The identifier of the current phase.
 * @returns {JSX.Element} Breadcrumbs component JSX.
 */
const Breadcrumbs = ({ phases = [], currPhase }) => {
  return (
    <div data-testid="breadcrumbs-bar" className={"breadcrumbs-bar"}>
      {phases.map((phase, index, arr) => {
        const { currTitle } = phase;
        const isLastItem = index === arr.length - 1;
        return (
          <Fragment key={index}>
            <span data-testid="breadcrumb-item" className={phase.currPhase === currPhase ? "selected" : ""}>{currTitle}</span>
            {!isLastItem && <span>{` >> `}</span>}
          </Fragment>
        );
      })}
    </div>
  );
};

Breadcrumbs.propTypes = {
  phases: propTypes.arrayOf(
    propTypes.shape({
      currTitle: propTypes.string.isRequired,
      currPhase: propTypes.string.isRequired,
    })
  ),
  currPhase: propTypes.string.isRequired,
};

export default Breadcrumbs;


// WEBPACK FOOTER //
// ./src/libraries/Breadcrumbs/index.jsx